import axios from 'axios'

export default props => {

      const validQueryParams = new Set([
      "lurker_id",
      "list_id",
      "test_id",
      "platform",
      "object_name",
      "custom_tag",
      "category_id",
      "subcategory_id",
      "region_id",
      "state_id",
      "keyword_search",
      "ad_price",
      "sd_id",
      "zone_id",
      "last_ads_seen"
    ])

    const REC_PARAMS = Object.keys(props)
      .filter(key => validQueryParams.has(key) && props[key] !== null)
      .map(key => {
        const value = props[key]
        if (Array.isArray(value)) {
          return value.map(v => key + '=' + v)
          .join('&')
        } else {
          return key + '=' + value
        }
      })
      .join('&')

    const BASE_URL_REC = 'https://recommendation.olx.com.br/api/rec/'

    return axios.get(`${BASE_URL_REC}?${REC_PARAMS}`)
      .then(response => {
        if (response.status === 200) {
          return response;
        } else {
          let error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .then(response => response.data)
      .then(responseJson => {
        if (!Array.isArray(responseJson)) {
          responseJson = Array(responseJson)
        }
        return responseJson
      })
      .catch(error => {
        console.log("Request Failed")
        return []
      })
  }





// WEBPACK FOOTER //
// ./src/node_modules/components/Pimper/actions/fetchAds.js